var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWestEastFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 170,
    viewBox: "0 0 200 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.5 90.5L47 91.5L58.5 67.5L66.5 65.5V56.5L80.5 54L81.5 62L125 49L123 52L92.5 90.5Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5 91H100V154.902L54.5 128.634V91Z",
    stroke: "#FF0000",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125 50.5L93 87.5V90.5H100V155.5L144.5 132.5V87.5H153L125 50.5Z",
    stroke: "#FF0000",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118 144.5V98.5H131V139L118 144.5Z",
    fill: "#FF0000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61 101.5L70 102.5V120.5L61 119.5V101.5Z",
    fill: "#FF0000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77 103.5L90 105.5V123.5L77 121.5V103.5Z",
    fill: "#FF0000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M109.184 26.9999C109.186 29.436 108.218 31.772 106.497 33.4956C104.775 35.2192 102.439 36.1872 100.003 36.1888C97.5668 36.1888 95.2308 35.2223 93.5072 33.5002C91.7836 31.7782 90.8156 29.442 90.8156 27.0061C90.8156 24.5702 91.7821 22.2324 93.5057 20.5104C95.2277 18.7883 97.5639 17.8203 99.9998 17.8203C102.434 17.8203 104.77 18.7868 106.492 20.5088C108.214 22.2294 109.183 24.5652 109.184 26.9999ZM99.9999 12L97.85 15.7257L102.15 15.7273L99.9999 12ZM102.15 38.265H97.85L99.9999 42L102.15 38.265ZM85 26.9999L88.7257 29.1498L88.7273 24.85L85 26.9999ZM111.265 24.85V29.1498L115 26.9999L111.265 24.85ZM110.608 16.3919L106.451 17.5077L109.492 20.5486L110.608 16.3919ZM93.5487 36.5012L90.5077 33.4603L89.392 37.6075L93.5487 36.5012ZM89.3919 16.3919L90.5077 20.5487L93.5486 17.5077L89.3919 16.3919ZM109.501 33.4511L106.46 36.4921L110.617 37.6078L109.501 33.4511Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWestEastFace);
export default __webpack_public_path__ + "static/media/WestEastFace.4beb24f08f586527c7eaba8d1b3b4ec1.svg";
export { ForwardRef as ReactComponent };